import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Waypoint } from 'react-waypoint';
import ScrollableAnchor, { configureAnchors } from 'react-scrollable-anchor';
import TableOfContentStore from './store';

const getBlockElementByKey = key =>
  document.querySelectorAll(`[data-offset-key^="${key}"][data-block="true"]`);

if (global.window !== undefined) {
  if ('scrollRestoration' in window.history) {
    // Back off, browser, I got this...
    window.history.scrollRestoration = 'manual';
  }

  configureAnchors({
    offset: -window.innerHeight / 2,
    scrollDuration: 300,
    keepLastAnchorHash: true,
  });
}

const createViewportChecker = (onViewportChange, props) =>
  class ViewportCheck extends Component {
    static defaultProps = {
      children: null,
      decoratedText: null,
      offsetKey: null,
    };
    static propTypes = {
      children: PropTypes.any,
      decoratedText: PropTypes.string,
      offsetKey: PropTypes.string,
    };

    onViewportChange = e => {
      const { offsetKey, decoratedText } = this.props;
      if (!offsetKey) return;
      const element = getBlockElementByKey(offsetKey)[0];
      onViewportChange({ text: decoratedText, offsetKey, element, ...e });
    };

    render() {
      const { children, offsetKey, ...restProps } = this.props;
      return (
        <Waypoint
          onPositionChange={this.onViewportChange}
          {...restProps}
          {...props}
        >
          <span className="waypoint-marker">
            <ScrollableAnchor id={offsetKey.replace('-0-0', '')}>
              <span />
            </ScrollableAnchor>
            {children}
          </span>
        </Waypoint>
      );
    }
  };

const createPlugin = ({ blockTypes }) => {
  const editorProps = {
    getReadOnly: undefined,
    getPage: undefined,
  };

  const headlineInViewportCallback = blockdata =>
    TableOfContentStore.setPosition(blockdata);

  const TOC = createViewportChecker(headlineInViewportCallback, {
    ...editorProps,
    blockTypes,
  });

  return {
    initialize: ({ getProps }) => {
      editorProps.getReadOnly = () => getProps().appStore.editMode;
      editorProps.getPage = () => getProps().page;
    },
    decorators: [
      {
        strategy: (contentBlock, callback) => {
          if (blockTypes.indexOf(contentBlock.getType()) !== -1) {
            callback(0, contentBlock.getText().length);
          }
        },
        component: TOC,
      },
    ],
  };
};

export default createPlugin;
